// extracted by mini-css-extract-plugin
module.exports = {"oldValue":"PolicyDiffComponent_oldValue__28-EN","newValue":"PolicyDiffComponent_newValue__2bCCP"};